import React from 'react';
import message from 'antd/lib/message';
import { loginWithPassword, changePassword, logout } from 'meteor-apollo-accounts';
import ApolloClient from 'ApolloClient';
import { detect } from 'detect-browser';
import notification from 'antd/lib/notification';
import Icon from 'components/common/Icon';

// export const handleLogin = (email, password, _this) => {
//     loginWithPassword({ email, password }, ApolloClient)
//       .then(userId => afterLogin(userId, ApolloClient, _this))
//       .catch(res => alertErrors(res, _this));
//     //onTokenChange(({ userId, token }) => Meteor.loginWithToken(token, () => afterLogin(userId, props)));
// };

const handleLogin = ({ email, password }) => new Promise(async (resolve, reject) => {
  let res;
  const browser = detect();
  try {
    res = await loginWithPassword({ email, password }, ApolloClient);
  } catch (err) {
    reject(err);
  }
  // handle the case where we don't detect the browser
  switch (browser && browser.name) {
  case 'edge':
    notification.warning({
      message: 'Friendly reminder',
      placement: 'bottomRight',
      duration: 10,
      icon: <Icon type="smile" theme="twoTone" />,
      description:
            'It looks like you are using Edge browser. You can still use Cclariti with this browser, but we want to let you know that it works best in Google Chrome!',
    });
    break;
  case 'ie':
    notification.warning({
      message: 'Friendly reminder',
      placement: 'bottomRight',
      duration: 10,
      icon: <Icon type="smile" theme="twoTone" />,
      description:
            'It looks like you are using Internet Explorer. You can still use Cclariti with this browser, but we want to let you know that it works best in Google Chrome!',
    });
    break;
    // 'ie' 'edge'
  default:
    break;
  }

  resolve(res);
});

const handleLogout = () => new Promise(async (resolve, reject) => {
  let res;
  try {
    res = await logout(ApolloClient);
  } catch (err) {
    reject(err);
  }
  resolve(res);
});

const AccountHelpers = {
  handleLogin,
  handleLogout,
};

export default AccountHelpers;



// WEBPACK FOOTER //
// ./src/lib/helpers/AccountHelpers/index.js